"use client";

import type { HTMLAttributes, ReactNode, FC, Ref } from "react";
import { mergeClasses } from "@huub-web/utils";

import { containerStyle, contentStyle, iconStyle } from "./Obscured.css";
import { Icon } from "../Icon/Icon";

export type ObscuredProps = HTMLAttributes<HTMLDivElement> & {
  locked?: boolean;
  leading?: ReactNode;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * A Obscured is a small, interactive element that represents a piece of information.
 */
export const Obscured: FC<ObscuredProps> = ({
  locked,
  className,
  children,
  leading,
  ref,
  ...props
}) => (
  <div ref={ref} className={mergeClasses(containerStyle, className)} {...props}>
    {leading}
    <div className={contentStyle}>{children}</div>
    {locked && <Icon className={iconStyle} icon="lockFilled" size="s" />}
  </div>
);
